export const CustomerGender: {
    MALE: "MALE";
    FEMALE: "FEMALE";
    OTHER: "OTHER";
    UNKNOWN: "UNKNOWN";
} = {
    MALE: "MALE",
    FEMALE: "FEMALE",
    OTHER: "OTHER",
    UNKNOWN: "UNKNOWN",
};

export type CustomerGender = (typeof CustomerGender)[keyof typeof CustomerGender];
